import { Download } from '~/models/document/Download'

export class DownloadsState {
  public downloads: Download[] = []
}

export default (): DownloadsState => new DownloadsState()
